<med-section offset="64" type="flat">
    <div class="tac" center>
        <div>
            <img [src]="noAccessImagePath">
        </div>
        <p class="bold">
           {{ 'youDoNotHavePermissionsToAccessCrossStudyPortal' | translate}}
        </p>
    </div>
</med-section>